function parseJwt(token) {
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        return JSON.parse(jsonPayload);
    }
    catch (error) {
        console.error('Error parsing JWT token:', error);
        throw error;
    }
}
export function checkIsAdmin(cookies) {
    try {
        const token = cookies.get('token');
        if (!token) {
            console.warn('No token found in cookies');
            return false;
        }
        const decoded = parseJwt(token);
        const isAdmin = decoded['custom:admin'] === 'true' || decoded['custom:admin'] === true;
        return isAdmin;
    }
    catch (error) {
        console.error('Error checking admin status:', error);
        return false;
    }
}
